import js from "../assets/js.svg";
import rt from "../assets/react.png";
import py from "../assets/py.png";
import nt from "../assets/nxt.png";
import dj from "../assets/dj.png";
import dk from "../assets/dk.png";
import gh from "../assets/gh.webp";
import git from "../assets/git.png";
import psql from "../assets/psql.png";
import ts from "../assets/ts.svg";
import rest from "../assets/rest.png";
import tw from "../assets/tw.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import go from "../assets/go.png";
import vue from "../assets/vue.png";
import nodejs from "../assets/nodejs.png";
import mysql from "../assets/mysql.png";
import mongodb from "../assets/mongodb.png";
import gcp from "../assets/gcp.png";
import postman from "../assets/postman.png";
import graphql from "../assets/graphql.png";
import grpc from "../assets/grpc.png";
import firebase from "../assets/firebase.png";

const skill = [
  {
    name: "JavaScript",

    imageUrl: `${js}`,
  },
  {
    name: "Python",

    imageUrl: `${py}`,
  },
  {
    name: "TypeScript",

    imageUrl: `${ts}`,
  },
  {
    name: "Golang",

    imageUrl: `${go}`,
  },
  {
    name: "ReactJS",

    imageUrl: `${rt}`,
  },
  {
    name: "NextJS",

    imageUrl: `${nt}`,
  },
  {
    name: "VueJS",

    imageUrl: `${vue}`,
  },
  {
    name: "NodeJS",

    imageUrl: `${nodejs}`,
  },
  {
    name: "Django",

    imageUrl: `${dj}`,
  },
  {
    name: "PostgreSQL",

    imageUrl: `${psql}`,
  },
  {
    name: "MySQL",

    imageUrl: `${mysql}`,
  },
  {
    name: "MongoDB",

    imageUrl: `${mongodb}`,
  },
  {
    name: "Docker",

    imageUrl: `${dk}`,
  },
  {
    name: "GitHub",

    imageUrl: `${gh}`,
  },
  {
    name: "Git",

    imageUrl: `${git}`,
  },
  {
    name: "Postman",

    imageUrl: `${postman}`,
  },
  {
    name: "Firebase",

    imageUrl: `${firebase}`,
  },
  {
    name: "GCP",

    imageUrl: `${gcp}`,
  },
  {
    name: "HTML",

    imageUrl: `${html}`,
  },
  {
    name: "CSS",

    imageUrl: `${css}`,
  },
  {
    name: "TailwindCSS",

    imageUrl: `${tw}`,
  },
  {
    name: "REST API",

    imageUrl: `${rest}`,
  },
  {
    name: "GraphQL",

    imageUrl: `${graphql}`,
  },
  {
    name: "GRPC",

    imageUrl: `${grpc}`,
  },
];

export default function Skills() {
  return (
    <div id="skills" className="relative pt-20">
      <div className="max-w-7xl mx-auto px-4 text-center sm:px-6 lg:px-8 ">
        <div className="space-y-8 sm:space-y-12">
          <div className="space-y-5 sm:mx-auto sm:max-w-xl sm:space-y-4 lg:max-w-5xl">
            <h2 className="text-3xl font-semibold text-primary tracking-widest sm:text-6xl font-oleo uppercase">
              Toolbox
            </h2>
            <p className="text-xl text-neutral">
              These are the tools and technologies that I have recently been
              using. I am always looking to learn more, so if your project
              requires a different technology, please let me know!
            </p>
          </div>
          <ul className="mx-auto grid grid-cols-2 gap-x-4 gap-y-8 sm:grid-cols-4 md:gap-x-6 lg:max-w-5xl lg:gap-x-8 lg:gap-y-12 bg-base-300 py-8">
            {skill.map((item) => (
              <li key={item.name}>
                <div className="space-y-4">
                  <img
                    className="mx-auto h-20 w-20 rounded-full lg:w-24 lg:h-24 bg-base-300"
                    src={item.imageUrl}
                    alt=""
                  />
                  <div className="space-y-2">
                    <div className="text-lg font-medium text-neutral">
                      <h3>{item.name}</h3>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
